import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'contact_details_page' */ './ContactDetailsPage'),
);
